@use "../../styles/breakpoint.module.scss" as *;

.l1liHidden {
    display: none;
}

.l1NavLinkBase {
    display: flex;
    align-items: center;
    position: relative;
    height: var(--header-height);
    font: var(--font-button-16);
    letter-spacing: 0.04em;
    text-transform: uppercase;

    @media ($below-mobile) {
        height: auto;
    }
}

.l1NavLink {
    composes: l1NavLinkBase;
    padding-inline: var(--spacer-12);

    &[aria-expanded="true"]::after {
        content: "";
        position: absolute;
        bottom: 0;
        inset-inline: var(--spacer-12);
        height: 4px;
        background-color: var(--navy);
        z-index: 1;
    }
}

.l1NavLinkMobile {
    composes: l1NavLinkBase;
    width: 100%;
    padding-block: 16px;

    &.l1NavLinkActive {
        flex-direction: column-reverse;
        align-items: flex-start;
        gap: var(--spacer-24);

        > * {
            display: contents;
        }
    }
}

.caretRight {
    --width: var(--spacer-16);

    display: block;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    width: var(--width);
    height: var(--width);
    pointer-events: none;

    .l1NavLinkActive & {
        position: static;
        left: var(--labui-container-margin);
        right: auto;
        transform: scaleX(-1);
    }
}

.l1NavLinkAction {
    display: flex;
    align-items: center;
    gap: var(--spacer-12);

    > span {
        display: none;
        font: var(--font-button-12);

        .l1NavLinkActive & {
            display: block;
        }
    }
}
